// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3q_nk","buttons":"SendReceipts_buttons__OQpUS","email":"SendReceipts_email__O_a-N","bookApptTitle":"SendReceipts_bookApptTitle__3DyuK"};